<template>
  <form>
    <div class="is-padding">
      <div class="columns">
        <div class="column">
          <v-input
            id="last_name"
            :name="'last_name'"
            @input="val => invitation.lastName = val"
            :model="invitation.lastName"
            :errors-bag="errors"
            ref="input"
            v-validate="'required|min:2'"
            data-vv-value-path="val"
            data-vv-as="Nom">
            <r-label
              slot="label"
              :is-required="true"
              :label="'Nom'"
              :value="invitation.lastName"></r-label>
          </v-input>
        </div>
        <div class="column">
          <v-input
            id="first_name"
            :name="'first_name'"
            @input="val => invitation.firstName = val"
            :model="invitation.firstName"
            :errors-bag="errors"
            v-validate="'required|min:2'"
            data-vv-value-path="val"
            data-vv-as="Prénom">
            <r-label
              slot="label"
              :is-required="true"
              :label="'Prénom'"
              :value="invitation.firstName"></r-label>
          </v-input>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <v-input
            id="email"
            :name="'email'"
            @input="val => invitation.email = val"
            :model="invitation.email"
            :errors-bag="errors"
            v-validate="'required|min:2'"
            data-vv-value-path="val"
            data-vv-as="Email">
            <r-label
              slot="label"
              :is-required="true"
              :label="'Email'"
              :value="invitation.email"></r-label>
          </v-input>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <div class="field">
            <r-label
              :is-required="false"
              :label="'Programmes'"
              :value="preAccess"></r-label>
            <div class="control">
              <multiselect
                id="selected-program"
                class="multiselect--option-ico"
                name="selected-program"
                value="pk"
                @input="updateremByProg"
                v-model="preAccess"
                :options="programs"
                :multiple="true"
                :searchable="true"
                :close-on-select="false"
                :show-labels="false"
                :placeholder="''"
                :custom-label="v => `${v.name}`"
                track-by="pk"
                @search-change="getPrograms">
                <span slot="placeholder">Sélectionnez un programme</span>
                <span slot="noOptions">La liste est vide</span>
              </multiselect>
            </div>
          </div>
        </div>
      </div>
      <div
        class="title is-5 has-text-weight-bold is-margin-bottom-xsmall"
        v-if="invitation.remByProg.length">
        Taux de commercialisation par programme
      </div>
      <template v-if="invitation.remByProg.length">
        <div
          class="columns column"
          v-for="(elem) in invitation.remByProg"
          :key="elem.program + '-' + elem.program_name">
          <!-- <v-input
            v-validate="'required'"
            :id="'rem-' + elem.program"
            :name="'rem-' + elem.program"
            @input="addRem($event, elem.program)"
            :model="elem.rem"
            :errors-bag="errors"
            data-vv-value-path="val"
            :data-vv-as="'Remuneration Programme ' + elem.program_name">
            <r-label slot="label" :is-required="false" :label="elem.program_name" :value="elem.rem"></r-label>
          </v-input> -->
          <v-input
            :id="'rem-' + elem.program"
            :name="'rem-' + elem.program"
            :classes-input="'is-active is-input'"
            :has-incrementations="true"
            input-type="number"
            @input="addRem($event, elem.program)"
            :model="elem.rem"
            :has-addons="true"
            :max="100"
            :step="1"
            :number="true"
            v-validate="'required|decimal:2'"
            :errors-bag="errors"
            data-vv-value-path="val"
            data-vv-as=" ">
            <r-label
              slot="label"
              :is-required="false"
              :label="elem.program_name"
              :value="elem.rem"></r-label>
            <p
              class="control"
              slot="addonRight">
              <a class="button is-border is-square is-static">
                <span class="icon"><i class="fas fa-percentage"></i></span>
              </a>
            </p>
            <span slot="provocatedError">
              <p
                v-if="tauxError.includes(elem.program)"
                class="help is-danger">
                Le taux doit être inférieur à 100%
              </p>
            </span>
          </v-input>
        </div>
      </template>
    </div>
  </form>
</template>

<script>
export default {
  name: 'UserInvitation',
  props: {
    paramsQuickview: {
      type: Object
    }
  },
  data () {
    return {
      programs: [],
      tauxError: [],
      invitation: {
        remByProg: [],
        preAccessList: [],
        email: null,
        firstName: null,
        lastName: null
      },
      preAccess: []
    }
  },
  created () {
    this.getPrograms()
  },
  methods: {
    updateremByProg (programs) {
      let remByProgTab = []
      for (let program of Object.values(programs)) {
        let elem = {
          program_name: program.name,
          program: program.pk,
          remuneration: null
        }
        remByProgTab.push(elem)
      }
      this.$set(this.invitation, 'remByProg', remByProgTab)
    },
    addRem (rem, pk) {
      for (let elem of this.invitation.remByProg) {
        if (elem.program === pk) {
          if (rem > 100 && !this.tauxError.includes(pk)) {
            this.tauxError.push(pk)
          } else if (rem <= 100 && this.tauxError.includes(pk)) {
            let index = this.tauxError.findIndex(x => x === pk)
            this.tauxError.splice(index, 1)
          }
          elem.remuneration = rem
        }
      }
    },
    async getPrograms (query) {
      let params = {
        per_page: 200,
        sort: 'name'
      }
      let request = await this.$api.get(this.$resources.PROGRAM, params)
      this.programs = request.data.items
    },
    async submitQuickview () {
      const formIsValid = await this.$validator.validateAll()
      if (formIsValid) {
        if (Array.isArray(this.preAccess)) this.$set(this.invitation, 'preAccessList', this.preAccess.map(x => x.pk || x))
        else if (typeof this.preAccess === 'object') this.$set(this.invitation, 'preAccessList', this.preAccess.pk)
        this.$emit('submitQuickview', this.invitation)
      }
    }
  }
}
</script>
